<div class="container">
  <div class="table-header">
    <div class="table-title">
      <div class="table-icon">
        <i nz-icon nzType="account-book"></i>
      </div>
      <div class="table-name">
        <span>Ledgers</span>
      </div>
    </div>
    <div class="table-action-controls">
      <div class="table-action-filter">
        <nz-input-wrapper>
          <ng-container nzInputPrefix><ng-container *ngTemplateOutlet="prefixIconSearch"></ng-container></ng-container>
          <input
            (input)="onSearch($event)"
            nz-input
            placeholder="Search"
            style="width: 300px"
            type="text"
          />
          <ng-container nzInputSuffix><ng-container *ngTemplateOutlet="SuffixIconSearch"></ng-container></ng-container>
        </nz-input-wrapper>
        <ng-template #prefixIconSearch>
          <i nz-icon nzType="search"></i>
        </ng-template>
        <ng-template #SuffixIconSearch>
          <i
            nz-icon
            nzType="table"
            (click)="toggleColumnFilters()"
            [ngClass]="{ 'ant-filter-active': showColumnFilters }"
            style="cursor: pointer"
          ></i>
        </ng-template>
      </div>
      <div class="table-action-create">
        <button (click)="showModal()" nz-button nzType="primary">
          <b><span nz-icon nzType="plus"></span></b>New
        </button>
      </div>
      <div class="table-action-refresh">
        <button nz-button><span nz-icon nzType="sync"></span></button>
      </div>
      <div class="table-action-settings">
        <button nz-button><span nz-icon nzType="setting"></span></button>
      </div>
      <div class="table-action-dropdown">
        <button nz-button><span nz-icon nzType="menu"></span></button>
      </div>
    </div>
  </div>
</div>
<div class="table-body">
  <nz-table
    #basicTable
    [nzData]="filteredLedgerCodes"
    [nzScroll]="{ y: tableHeight + 'px' }"
    [nzShowPagination]="false"
    nzSize="small"
    style="border: solid 1px #e6e6e6; border-bottom: none"
  >
    <thead style="padding: 5px">
      <tr>
        <th [nzSortFn]="sortLedgerType" nzShowSort nzWidth="15%" style="color: #777">
          Ledger Type
        </th>
        <th [nzSortFn]="sortSection" nzShowSort nzWidth="22%" style="color: #777">Section</th>
        <th [nzSortFn]="sortDetails" nzShowSort nzWidth="30%" style="color: #777">Details</th>
        <th [nzSortFn]="sortD365Code" nzShowSort nzWidth="22%" style="color: #777">D365 Code</th>
        <th nzWidth="11%"></th>
      </tr>
      <tr *ngIf="showColumnFilters">
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('ledgerType', $event)"
            [value]="columnFilters['ledgerType'] || ''"
          />
        </th>
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('sectionId', $event)"
            [value]="columnFilters['sectionId'] || ''"
          />
        </th>
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('sectionName', $event)"
            [value]="columnFilters['sectionName'] || ''"
          />
        </th>
        <th>
          <input
            nz-input
            (input)="updateColumnFilter('d365Code', $event)"
            [value]="columnFilters['d365Code'] || ''"
          />
        </th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let ledgerCode of filteredLedgerCodes">
        <td style="border-bottom: none">
          <a (click)="editLedgerCode(ledgerCode)">{{
            getLedgerTypeLabel(ledgerCode.ledgerType)
          }}</a>
        </td>
        <td style="border-bottom: none">{{ ledgerCode.sectionId }}</td>
        <td style="border-bottom: none">{{ ledgerCode.sectionName }}</td>
        <td style="border-bottom: none">{{ ledgerCode.d365Code }}</td>
        <td style="border-bottom: none">
          <div class="action-button">
            <i (click)="editLedgerCode(ledgerCode)" nz-icon nzType="edit"></i>
            <i
              (nzOnConfirm)="deleteLedgerCode(ledgerCode.id)"
              nz-icon
              nz-popconfirm
              nzCancelText="Cancel"
              nzOkText="Yes"
              nzOkType="primary"
              nzPopconfirmPlacement="bottom"
              nzPopconfirmTitle="Are you sure to delete?"
              nzType="delete"
            ></i>
          </div>
        </td>
      </tr>
    </tbody>
  </nz-table>
  <div *ngIf="!filteredLedgerCodes?.length">No data to display!</div>
</div>
<div class="footer">
  <div class="data-count" style="margin-left: 10px">
    {{ filteredLedgerCodes?.length || 0 }} Records
  </div>
</div>

<nz-modal
  (nzOnCancel)="handleCancel()"
  [(nzVisible)]="isVisible"
  [nzFooter]="modalFooter"
  [nzOkLoading]="isOkLoading"
  [nzTitle]="isEditMode ? 'Edit Ledger Code' : 'Add Ledger Code'"
  nzWidth="50%"
>
  <form [formGroup]="ledgerCodeForm">
    <div *nzModalContent class="ledgerCodeForm">
      <div
        nz-row
        [nzGutter]="16"
        style="display: flex; flex-wrap: wrap; justify-content: space-between"
      >
        <div [nzSpan]="11" nz-col style="margin-bottom: 10px">
          <label><span>*</span>Ledger Type</label>
          <nz-select
            (ngModelChange)="onLedgerTypeChange()"
            formControlName="ledgerType"
            style="width: 100%"
          >
            <nz-option
              *ngFor="let option of ledgerTypeOptions"
              [nzLabel]="option.key"
              [nzValue]="option.value"
            ></nz-option>
          </nz-select>
        </div>

        <div [nzSpan]="11" nz-col style="margin-bottom: 10px">
          <label><span>*</span>Section</label>
          <nz-select
            (ngModelChange)="onSectionChange()"
            [disabled]="$safeNavigationMigration(ledgerCodeForm.get('sectionId')?.disabled)"
            formControlName="sectionId"
            style="width: 100%"
          >
            <nz-option
              *ngFor="let section of filteredSections"
              [nzLabel]="section.name"
              [nzValue]="section.id"
            ></nz-option>
          </nz-select>
        </div>

        <div [nzSpan]="11" nz-col style="margin-bottom: 10px">
          <label><span>*</span>Details</label>
          <input formControlName="sectionName" nz-input readonly required style="width: 100%" />
        </div>

        <div [nzSpan]="11" nz-col style="margin-bottom: 10px">
          <label><span>*</span>D365 Code</label>
          <input formControlName="d365Code" nz-input required style="width: 100%" type="text" />
        </div>
      </div>
    </div>
  </form>
</nz-modal>

<ng-template #modalFooter>
  <div style="display: flex; justify-content: flex-end; gap: 5px; padding: 5px">
    <button (click)="handleSave()" nz-button nzType="primary">
      <i nz-icon nzType="save" style="margin-right: 5px"></i> Save
    </button>
    <button (click)="handleCancel()" nz-button nzType="default">Cancel</button>
  </div>
</ng-template>
